import React, { useState } from 'react'
import StopProgramModalContent from './StopProgramModalContent'
import { ContentModal } from 'ui/acro'
import { axios } from 'api'
import { camelToSnake } from 'utils'
import { dispatchProgramAction } from 'components_v1/programs/ProgramButtonActions'

const StopProgramModal = ({
  selectedProgramSlug,
  useModal,
  fetchProgramData = () => {}
}) => {
  const [isSubmitting, setIsSubmitting] = useState(false)
  const stopProgram = async (slug) => {
    if (!slug) return
    setIsSubmitting(true)
    try {
      const res = await axios.post(`/programs/${slug}/stop`)
      dispatchProgramAction('stop')
      if (res?.data?.ga4Event) {
        window.dataLayer ||= []
        window.dataLayer.push(camelToSnake(res.data?.ga4Event))
      }
      if (res) {
        fetchProgramData({ isRemove: true })
        useModal.close()
      }
    } catch (e) {
      console.log('e', e)
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <ContentModal
      style={{
        maxHeight: 'unset',
        maxWidth: '496px',
        width: '100%',
        borderRadius: '0px',
        borderWidth: '0px'
      }}
      useModal={useModal}
      overflow='hidden'
    >
      <StopProgramModalContent
        onSubmit={() => stopProgram(selectedProgramSlug)}
        onCancel={() => useModal.close()}
        isDeskTop={true}
        isSubmitting={isSubmitting}
      />
    </ContentModal>
  )
}

export default StopProgramModal
